import React, { useEffect, useState } from "react";
import Navbar from "../../../Navbar";
import Sidebar from "../../../Sidebar";
import AccordionTaxasFormaPagamento from "./AccordionTaxasFormaPagamentot";
import AccordionDadosEmpresa from "./AccordionDadosEmpresa";
import { listPaymentMethodsByCompany } from "../../../services/PaymentMethodService";
import { connect, disconnect, status } from "../../../services/WhatsappService";
import { CDBSpinner } from "cdbreact";
import { getCompanyInfo } from "../../../services/CompanyService";
import { toast } from "react-toastify";
import "./styles.css";
import FidelidadeTab from "./FidelidadeTab";
// IMPORTANTE: Importando o Modal do Reactstrap para controlar via estado!
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";

export const Configuracoes = () => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [toggled, setToggled] = useState(false);
  const [qrcode, setQrcode] = useState();
  const [whatsAppConnected, setWhatsAppConnected] = useState(false);
  const [loading, setLoading] = useState(true);
  const [companyInfo, setCompanyInfo] = useState();
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);
  const [isConnecting, setIsConnecting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    statusWhatsApp();
    loadCompanyInfo();
    handleSidebarToggle();
    loadPaymentMethods();
  }, []);

  function loadPaymentMethods() {
    listPaymentMethodsByCompany(false)
      .then((response) => {
        setPaymentMethods(response);
      })
      .catch((error) => console.error(error));
  }

  function handleSidebarToggle() {
    const isMobile = window.innerWidth <= 720;
    if (isMobile) {
      setToggled(true);
    }
  }

  function loadCompanyInfo() {
    getCompanyInfo()
      .then((response) => {
        setCompanyInfo(response);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  }

  function connectWhatsApp() {
    setIsConnecting(true);

    connect()
      .then((response) => {
        if (!response.base64) {
          toast.warning(
            "Limite de tentativas atingido. Aguarde 5 minutos e tente novamente."
          );
          return;
        }

        setQrcode(response.base64);
        setIsQrModalOpen(true);
      })
      .catch((error) => {
        toast.error(
          "Não foi possivel gerar QRCode. Atualize a pagina e tente novamente."
        );
      })
      .finally(() => {
        setIsConnecting(false);
      });
  }

  function disconnectWhatsApp(e) {
    e.preventDefault();

    const executeAction = window.confirm(
      "Tem certeza que deseja desconectar seu WhatsApp?\nMensagens de ordem de serviço, marketing e outras não poderão mais ser enviadas."
    );

    if (executeAction) {
      setIsConnecting(true);
      disconnect()
        .then((response) => {
          setQrcode();
          setWhatsAppConnected(false);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setIsConnecting(false);
        });;
    }
  }

  function statusWhatsApp() {
    status(false)
      .then((response) => {
        setWhatsAppConnected(response);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  return (
    <div className="d-flex">
      <div>
        <Sidebar toggled={toggled} />
      </div>
      <div className="main-content-wrapper">
        <Navbar toggled={toggled} setToggled={setToggled} />
        <div style={{ height: "100%" }}>
          <div style={{ padding: "20px 5%" }}>
            <div>
              {/* Passando o estado e a função de fechar para o Modal */}
              <QRCodeModal
                qrcode={qrcode}
                isOpen={isQrModalOpen}
                onClosed={() => statusWhatsApp()}
                toggle={() => setIsQrModalOpen(!isQrModalOpen)}
              />

              <div className="mt-3">
                <div className="d-lg-flex justify-content-between">
                  <div>
                    <h3 className="fw-bold text-dark">Configurações</h3>
                  </div>
                  <div className="mb-2">
                    {!whatsAppConnected ? (
                      <button
                        className="btn btn-outline-primary fw-bold rounded-3"
                        onClick={() => connectWhatsApp()}
                        disabled={isConnecting} // Desabilita clique duplo
                      >
                        {isConnecting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Gerando QRCode...
                          </>
                        ) : (
                          <>
                            <i className="fa fa-qrcode me-2"></i>
                            Conectar WhatsApp
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        className="btn btn-outline-danger fw-bold rounded-3"
                        onClick={(e) => disconnectWhatsApp(e)}
                      >
                        <i className="fa fa-power-off me-2"></i>
                        Desconectar WhatsApp
                      </button>
                    )}
                  </div>
                </div>
                {loading ? (
                  <div className="d-flex justify-content-center p-5">
                    <CDBSpinner dark />
                  </div>
                ) : (
                  <>
                    <div className="mt-3">
                      <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            id="tab1"
                            data-bs-toggle="tab"
                            href="#content1"
                          >
                            Empresa
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            id="tab2"
                            data-bs-toggle="tab"
                            href="#content2"
                          >
                            Taxas
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            className="nav-link"
                            id="tab2"
                            data-bs-toggle="tab"
                            href="#fidelidadeTab"
                          >
                            Cartão Fidelidade
                          </a>
                        </li>
                      </ul>

                      <div className="tab-content">
                        <div
                          className="tab-pane fade show active"
                          id="content1"
                        >
                          <AccordionDadosEmpresa
                            companyInfo={companyInfo}
                            loadCompanyInfo={loadCompanyInfo}
                          />
                        </div>

                        <div className="tab-pane fade" id="content2">
                          <AccordionTaxasFormaPagamento
                            paymentMethods={paymentMethods}
                            listPayments={loadPaymentMethods}
                          />
                        </div>

                        <div className="tab-pane fade" id="fidelidadeTab">
                          <FidelidadeTab />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// MODAL REFATORADO PARA USAR O REACTSTRAP
const QRCodeModal = (props) => {
  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggle}
      onClosed={props.onClosed} // Exemplo de ação ao fechar o modal
      backdrop="static" // Obriga a clicar no botão fechar
      centered
      contentClassName="border-0 shadow-lg rounded-4"
    >
      <ModalHeader toggle={props.toggle} className="border-0 pb-0 pt-4 px-4">
        <h5 className="modal-title fw-bold text-dark">
          <i className="fab fa-whatsapp text-success me-2"></i>
          Conectar WhatsApp
        </h5>
      </ModalHeader>

      <ModalBody className="text-center p-4">
        <div className="mb-4 text-muted small fw-medium">
          No seu celular abra o WhatsApp, vá em "Dispositivos conectados" e clique em "Conectar dispositivo". Depois escaneie o QRCode abaixo.
        </div>

        {/* Como o modal só abre no sucesso, a imagem sempre existirá, dispensando o spinner interno */}
        <div className="bg-light p-3 rounded-4 d-inline-block border">
          <img className="img-fluid rounded-3" src={props.qrcode} alt="QR Code WhatsApp" />
        </div>
      </ModalBody>

      <ModalFooter className="border-0 pt-0 pb-4 px-4">
        <button
          type="button"
          className="btn btn-primary container-fluid fw-bold rounded-pill p-2"
          onClick={props.toggle}
        >
          Concluir
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default Configuracoes;